import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import './App.css';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import EditorialMarquee from './components/EditorialMarquee';
import GalleryGrid from './components/GalleryGrid';
import AboutManifesto from './components/AboutManifesto';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  const [galleryFilter, setGalleryFilter] = useState('All');

  // Lenis smooth scroll (graceful degradation if not installed)
  useEffect(() => {
    let rafId;
    let lenis;
    import('lenis').then(module => {
      const Lenis = module.default;
      lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
      const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
      rafId = requestAnimationFrame(raf);
    }).catch(() => {});
    return () => { if (rafId) cancelAnimationFrame(rafId); if (lenis) lenis.destroy(); };
  }, []);

  return (
    <div style={{ background: '#FDFCF7', minHeight: '100vh' }}>
      <Toaster position="bottom-right" richColors />
      <Navigation />
      <main>
        <HeroSection onFilterChange={setGalleryFilter} galleryFilter={galleryFilter} />
        <EditorialMarquee />
        <GalleryGrid filter={galleryFilter} onFilterChange={setGalleryFilter} />
        <AboutManifesto />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
